import { COMPANY } from "@/data/site";

const WA_NUMBER = "491629429140";
const WA_TEXT = encodeURIComponent(
  "Hallo S&P Reinigungsservice, ich interessiere mich für Ihre Leistungen und hätte gerne ein Angebot."
);

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Chat über WhatsApp starten"
      className="group fixed bottom-6 right-6 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3.5 shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform duration-200 hover:scale-105 active:scale-95"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: "2.2s" }} />
      <span className="relative flex items-center gap-3">
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white" aria-hidden="true">
          <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.114.553 4.176 1.6 5.995L4 29l8.2-1.55a11.94 11.94 0 0 0 3.803.62h.003C22.62 28.07 28 22.687 28 16.067 28 9.447 22.62 3 16.003 3zm0 21.86h-.003a9.9 9.9 0 0 1-3.42-.6l-.245-.09-4.87.92.93-4.745-.16-.245a9.86 9.86 0 0 1-1.5-5.997c0-5.485 4.463-9.947 9.95-9.947 2.66 0 5.16 1.037 7.04 2.92a9.88 9.88 0 0 1 2.912 7.03c0 5.485-4.463 9.947-9.947 9.947zm5.46-7.44c-.3-.15-1.77-.873-2.043-.973-.273-.1-.473-.15-.673.15-.2.3-.773.973-.948 1.173-.174.2-.35.223-.648.075-.3-.15-1.263-.466-2.405-1.485-.888-.792-1.487-1.77-1.662-2.07-.174-.3-.019-.462.13-.61.134-.134.3-.35.45-.524.15-.174.2-.3.3-.5.1-.2.05-.374-.025-.524-.075-.15-.673-1.62-.922-2.22-.243-.583-.49-.504-.673-.514l-.573-.01c-.2 0-.524.075-.798.374-.274.3-1.047 1.023-1.047 2.494s1.072 2.893 1.222 3.093c.15.2 2.11 3.22 5.11 4.514.714.308 1.27.492 1.705.63.716.228 1.368.196 1.884.119.575-.086 1.77-.724 2.02-1.423.25-.7.25-1.298.175-1.423-.075-.124-.274-.2-.574-.35z" />
        </svg>
        <span className="hidden sm:block font-mono text-xs font-medium uppercase tracking-[0.1em] text-white">
          WhatsApp
        </span>
      </span>
    </a>
  );
}
